import omit from 'lodash/omit';

import type { Filter, VehicleListFilterQuery } from 'Types/filter';
import formatQueryToFilters from 'Utilities/filterQuery/formatQueryToFilters';

export const getInitialFilters = (query: VehicleListFilterQuery): Filter => {
	// excluding some filters as these need special handling - see useVehicleListFilterQuery
	// TODO: Work out if we should still be excluding buying format
	const queryWithExcluded = omit(query, ['listType']);

	return formatQueryToFilters(queryWithExcluded) as Filter;
};
